import { defineAppConfig, defineDataLoader, history, runApp, IAppConfig } from 'ice';
import { fetchUserInfo } from './services/user';
import { fetchSiteSettings } from './services/settings';
import { fetchPolicy } from './services/policy';
import Requests from '@/services/request';
import initCollector, { uc } from '@alife/utopia-collector';
import initSlSCollectcor  from '@alife/utopia-collector/dist/index-sls.js';
import { getEnv, safetyRequest } from './utils';
import { defineAuthConfig } from '@ice/plugin-auth/esm/types';
import { defineStoreConfig } from '@ice/plugin-store/esm/types';
import { registerResponseHook  } from '@alife/superapp-common-adapters';
import { errorHandler } from './services/request';
import './assets/font/iconfont.css';
import './assets/iconfont/iconfont.css';

import appCenter, { init } from '@alife/superapp-app-center';

import { getQueryStringArgs } from '@/utils/url-parse';

// import '@b-design/fusion/dist/theme/variables.blue.css'; // 引入指定主题包样式文件
// import '@alifd/next/dist/next-noreset.var.min.css'; // 引入@alifd/next指定样式文件
// import '@b-design/fusion/dist/index.css'; // 引入@b-design/fusion全量组件样式文件

import './override.less';

if (!String.prototype.at) {
  String.prototype.at = function (index) {
    return this.charAt(index);
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    if (index >= 0) {
      return this[index];
    } else {
      return this[this.length + index];
    }
  };
}

function hexToRgb(hex) {
  // 去除字符串开头的'#'
  const _hex = hex.replace('"', '').replace('#', '');
  // 将十六进制值转换为RGB
  const bigint = parseInt(_hex, 16);
  return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
}

const secondary1 = getComputedStyle(document.documentElement).getPropertyValue(
  '--superapp-secondary-1',
);
const secondary2 = getComputedStyle(document.documentElement).getPropertyValue(
  '--superapp-secondary-2',
);
const { r: r1, g: g1, b: b1 } = hexToRgb(secondary1);
const { r: r2, g: g2, b: b2 } = hexToRgb(secondary2);
if (secondary1 && secondary2) {
  document.documentElement.style.setProperty(
    '--superapp-miniapp-template-desc-bg',
    `linear-gradient(270deg, rgba(${r1}, ${g1}, ${b1}, 0.4) 0%, rgba(${r2}, ${g2}, ${b2}, 0.8) 100%)`,
  );
}


document.documentElement.style.setProperty(
  '--superapp-family-PingFangSC',
  window.__SUPERAPP_CONFIG__?.fontFamily || 'PingFangSC',
);

document.documentElement.style.setProperty(
  '--superapp-family-HelveticaNeue',
  window.__SUPERAPP_CONFIG__?.fontFamily || 'HelveticaNeue',
);

document.documentElement.style.setProperty(
  '--superapp-family-subTitle',
  window.__SUPERAPP_CONFIG__?.fontFamily || 'AlibabaSans,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;',
);

const style = document.createElement('style');
style.textContent = `
  * {
    font-family: ${window.__SUPERAPP_CONFIG__?.fontFamily || 'Helvetica Neue'};
  }
`;
document.head.appendChild(style);

window.microApps = window.__SUPERAPP_CONFIG__?.microApps || [];

if(window.__SUPERAPP_CONFIG__?.enableTracker)  {
  switch(window.__SUPERAPP_CONFIG__?.enableTracker) {
    case 'aem': {
       initCollector({
        pid: 'ZxHfSR',
        env: getEnv(),
        // language: getLanguage()
      });
    }; break;
    case 'sls': {

    }
  }
}
 
// App config, see https://ice3.alibaba-inc.com/v3/docs/guide/basic/app
import $i18n from './i18n';
export default defineAppConfig(() => ({
  router: {
    // type: 'browser',
    type: 'hash',
  },
}));

// const appConfig: IAppConfig = {`
//       router: {
//         // type: 'browser',
//         type: 'hash',
//       },
//       app: {
//         errorBoundary: true,  // 必须设置为true才行
//         onErrorBoundaryHandler: (error: Error) => {
//           console.log('huyuqiong error', error)
//           // 调用稳定性插件，上报异常
//           window.UtopiaCollector?.sendRenderError(error);
//         },
//        }
//     }
// }

export const authConfig = defineAuthConfig(async (appData) => {
  const { userInfo = {} } = appData;
  return {
    initialAuth: {
      admin: userInfo.userType === 'admin',
      user: userInfo.userType === 'user',
    },
  };
});

export const storeConfig = defineStoreConfig(async (appData) => {
  const { userInfo = {}, spaceInfo = {} } = appData;
  return {
    initialStates: {
      user: {
        currentUser: { ...(userInfo || {}), isUpdate: true },
      },
      spaceRole: spaceInfo,
    },
  };
});

export const dataLoader = defineDataLoader(async () => {
  const userInfo = await getUserInfo();
  const spaceInfo = await getSpaceInfo();
  const globalConfig = await getSiteConfig();
  const policyConfig = await getPolicyConfig();
  return {
    userInfo,
    globalConfig,
    policyConfig,
    spaceInfo,
  };
});

async function getUserInfo() {
  try {
    const userInfo = await fetchUserInfo();
    if (userInfo?.status === 4) {
      const href = window.location.href?.split?.('#/')?.[0];
      // window.location.replace(`${href}#/login?safetyModalVisible=true`);
      history?.push('/login?safetyModalVisible=true');
      return;
    }
    if (userInfo?.accountId && document?.referrer?.includes('account.alibabacloud.com')) {
      safetyRequest(() => {
        setTimeout(() => {
          Requests.post('/uc/risk/aliyun/report', {
            ...userInfo,
          });
        }, 0);
      });
    }
    return userInfo;
  } catch (error) {}
  return undefined;
}

async function getSpaceInfo() {
  try {
    if (location.hash?.includes('#/login')) {
      // 登录页面
      return {};
    }

    const spaceResponse = await Requests.get('/rest/intercnn/space/query', {
      status: 'ACTIVE',
      pageSize: 1000,
    });

    if (spaceResponse?.loginUrl) {
      return {};
    }

    const { spaceId } = getQueryStringArgs();

    const list =
      spaceResponse?.list?.map((item) => ({ ...item, roleList: item?.role?.split(',') || [] })) ||
      [];

    const listTemp = list.map((i) => ({ ...i, value: i?.spaceId, label: i?.name }));
    const urlSpace = listTemp.find((i) => i.spaceId === spaceId);
    const space = urlSpace || listTemp?.[0] || {};

    return { ...space, isUpdate: true };
  } catch (error) {
    return {};
  }
}

async function getSiteConfig() {
  try {
    const siteSettings = await fetchSiteSettings();
    return siteSettings;
  } catch (err) {}
  return undefined;
}

async function getPolicyConfig() {
  try {
    const Policy = await fetchPolicy();
    return Policy;
  } catch (err) {}
  return undefined;
}

const notLoginHandler = () => {
  errorHandler({ errorCode: 401 }, false);
  throw new Error(
    $i18n.get({ id: 'aopf.src.app.ChinesePleaseLoginFirst', dm: 'Please login first！' }),
  );
};

registerResponseHook(async (res) => {
  try {
    if (res.status === 401) {
      notLoginHandler();
      throw new Error('401');
    }
    let resData;
    if (res.clone) {
      resData = await res.clone().json();
    } else {
      resData = res;
    }
    const { success, errorCode } = resData;
    if (!success && errorCode === '401') {
      notLoginHandler();
      throw new Error('401');
    }
    return res;
  } catch (err) {
    if (
      err?.message ===
      $i18n.get({ id: 'aopf.src.app.ChinesePleaseLoginFirst', dm: 'Please login first！' })
    ) {
      return;
    }
    errorHandler({ errorCode: 500 }, false);
    throw new Error($i18n.get({ id: 'aopf.src.app.ChineseServerError', dm: 'Server error！' }));
  }
});

init({ locale: $i18n.siteLocale, basePath: '/superapp' });

